/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ヘッダーメニュー多階層(PC) */
/*
dataString: タブとコンテンツを紐つけるデータ属性
dataStringSnake: タブとコンテンツを紐つけるデータ属性
classOfContent: 
parentClass: タブとコンテンツのセットを束ねている親
switchedGrandChlidMenu: subメニューに親-子-孫の関係があるとき、親をクリックしたときに孫をリセットするためのもの
switchedGrandChlidSelector: 、親をクリックしたときに孫をリセットするためのもの
*/

let megaMenuSwitchContentsHandle = document.getElementsByClassName('mega-menu__switch-contents--handle');
for(let i=0; i < megaMenuSwitchContentsHandle.length; i++ ) {
  megaMenuSwitchContentsHandle[i].addEventListener('click', {dataString: 'menuHandle', dataStringSnake: 'data-menu-handle', classOfContent: 'mega-menu__columncontentswrapper', parentClass: 'mega-menu__columnwrapper' , switchedGrandChlidMenu: 'mega-menu__column', switchedGrandChlidSelector: 'mega-menu__switch-contents--index',  handleEvent: menuSwitch}, false );
}

let megaMenuSwitchContentsIndex = document.getElementsByClassName('mega-menu__switch-contents--index');
for(let i=0; i < megaMenuSwitchContentsIndex.length; i++ ) {
  megaMenuSwitchContentsIndex[i].addEventListener('click', {dataString: 'menuIndex', dataStringSnake: 'data-menu-index', classOfContent: 'mega-menu__column', parentClass: 'mega-menu__columncontentswrapper' , switchedGrandChlidMenu: '', handleEvent: menuSwitch}, false );
}

function menuSwitch(e) {
  const target = e.target;
  const activeSelector = target.closest('div').querySelector('.is-menu-selected');
  const targetData = target.dataset[this.dataString];
  const targetParent = target.closest('.' + this.parentClass);
  console.log(targetData);
  const targetMenu = targetParent.querySelector( '.' + this.classOfContent + '[' + this.dataStringSnake + '="' + targetData + '"' + ']');

  //is-menu-activeクラスがついている要素が選択中のときは処理を行わない
  if(!targetMenu.classList.contains('is-menu-active')){

    //3階層のとき→親を押したときに、子と孫の状態をリセット(1つめの要素に付け替え)
    if(this.switchedGrandChlidMenu && this.switchedGrandChlidSelector) {
      const activeChildMenu = targetParent.querySelector('.' + this.classOfContent + '.is-menu-active' + ' .' + this.switchedGrandChlidMenu + '.is-menu-active');
      const firstChildMenu = targetParent.querySelector('.' + this.classOfContent +  '.is-menu-active' + ' .' + this.switchedGrandChlidMenu );
      const activeChildSelector = targetParent.querySelector('.' + this.classOfContent + '.is-menu-active .' + this.switchedGrandChlidSelector + '.is-menu-selected');
      const firstChildSelector = targetParent.querySelector('.' + this.classOfContent + '.is-menu-active .' + this.switchedGrandChlidSelector );
      if(activeChildMenu){
        activeChildMenu.classList.remove('is-menu-active');
      }
      firstChildMenu.classList.add("is-menu-active");
      console.log(firstChildMenu);
      if(activeChildSelector) {
        activeChildSelector.classList.remove('is-menu-selected');
      }
      firstChildSelector.classList.add('is-menu-selected');
    }

    //is-menu-activeクラスがついている要素をリセットし付け替え
    const activeMenu = targetParent.querySelector( '.' + this.classOfContent + '.is-menu-active');
    if(activeMenu){
      activeMenu.classList.remove('is-menu-active');
    }
    targetMenu.classList.add('is-menu-active');
    if(activeSelector){
      activeSelector.classList.remove('is-menu-selected');
    }
    target.classList.add('is-menu-selected');
  }
}



/* 商品詳細タブ */

function tabSwitch(e, className) {
  const target = e.target;
  const activeSelector = target.closest('.' + className);

  const tab_elements = document.getElementsByClassName(className);
  console.log(tab_elements);
  Array.prototype.forEach.call(tab_elements, function (element) {
    console.log('sadfad')
    element.dataset.tabEnable = "";
  });
  activeSelector.dataset.tabEnable = "true"
}